function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { getScript, getResourceUrl as _getResourceUrl } from './globals';
import { getGlobal } from './compat';

var _window = getGlobal();
var _document = _window.document;

// Class for loading external resources, such as scripts and stylesheets
var ResourceLoader = /*#__PURE__*/function () {
  function ResourceLoader() {_classCallCheck(this, ResourceLoader);
    // Contains one promise for each requested resource
    this.loadPromises = {};
  }

  /**
     * Returns the full url of a resource with version.
     * The version will be determined from the LMV_VIEWER_VERSION variable.
     * @private
     * @param {string} url
     * @returns {string} The full resource path.
     */_createClass(ResourceLoader, [{ key: "getResourceUrl", value: function getResourceUrl(
    url) {
      return url.indexOf('://') > 0 ? url : _getResourceUrl(url);
    }

    /**
       * Load the es6 promise library
       * @param {*} onSuccess 
       * @param {*} onError 
       */ }, { key: "loadPromiseLibrary", value: function loadPromiseLibrary(
    onSuccess, onError) {
      if (_window['Promise'] !== undefined) {
        onSuccess();
        return;
      }

      var url = this.getResourceUrl('es6-promise.min.js');

      this.loadScriptIntoDom(url, onSuccess, onError);
    }

    /**
       * Load a script into the DOM
       * @param {string} url - relative or absolute url
       * @param {string} [libNamespace] - window property name expected to be loaded after library is downloaded. Can be undefined, too
       * @param {function} onSuccess - called when the script is loaded into the DOM
       * @param {function} [onError] - called when an error occurs
       */ }, { key: "loadScriptIntoDom", value: function loadScriptIntoDom(
    url, onSuccess, onError) {
      var s = _document.createElement('SCRIPT');
      s.src = url;

      var clearCallbacks = function clearCallbacks() {
        s.onerror = null;
        s.onload = null;
      };
      var errCallback = function errCallback(err) {
        clearCallbacks();
        onError && onError(new Error("Error loading script ".concat(url, ", with error ").concat(err)));
      };
      var successCallback = function successCallback() {
        clearCallbacks();
        onSuccess();
      };

      s.onload = successCallback;
      s.onerror = errCallback;

      _document.head.appendChild(s);
    }

    /**
       *
       * @param {string} url - relative or absolute url
       * @param {string} libNamespace - window property name expected to be loaded after library is downloaded. Can be undefined, too
       * @returns {Promise} - of successful load
       */ }, { key: "loadScript", value: function loadScript(
    url, libNamespace) {var _this = this;
      // library namespace already present, indicates already loaded
      if (libNamespace && _window[libNamespace] !== undefined) {
        return Promise.resolve();
      }

      url = this.getResourceUrl(url);
      var key = url.toLowerCase();
      if (key in this.loadPromises) {
        return this.loadPromises[key];
      }

      var script = getScript(url);
      if (script) {
        // already downloaded, resolve immediately
        this.loadPromises[key] = Promise.resolve();
      } else {
        // load the resource
        this.loadPromises[key] = new Promise(function (resolve, reject) {
          _this.loadScriptIntoDom(url, resolve, reject);
        });
      }

      return this.loadPromises[key];
    }

    /**
       *
       * @param {string} url - relative or absolute url
       * @returns {Promise} - of successful load
       */ }, { key: "loadCSS", value: function loadCSS(
    url) {
      url = this.getResourceUrl(url);

      var key = url.toLowerCase();
      if (url in this.loadPromises) {
        return this.loadPromises[key];
      }

      var css = this._getLink(url);
      if (css) {
        // already downloaded, resolve immediately
        this.loadPromises[key] = Promise.resolve();
      } else {
        // download it
        this.loadPromises[key] = new Promise(function (resolve, reject) {
          var s = _document.createElement('link');
          s.setAttribute('rel', 'stylesheet');
          s.setAttribute('type', 'text/css');
          s.setAttribute('href', href);

          s.onload = resolve;
          s.onerror = reject;

          _document.head.appendChild(s);
        });
      }

      return this.loadPromises[key];
    }

    /**
       *
       * @param {string} - valid url
       * @private
       */ }, { key: "_getLink", value: function _getLink(
    url) {
      var results = _document.getElementsByTagName('link');
      for (var i = 0, len = results.length; i < len; i++) {
        if (results[i].href === url) {
          // Already downloaded
          return results[i];
        }
      }
      return null;
    } }]);return ResourceLoader;}();


// export an immutable singleton
export var theResourceLoader = new ResourceLoader();
Object.freeze(theResourceLoader);


// For backwards compatibility, keep exporting avp.loadDependency()
// TODO: Remove in v8.0.0
export function loadDependency(libNamespace, libNameOrUrl, callback, onError /*,amdName*/) {
  theResourceLoader.loadScript(libNameOrUrl, libNamespace).
  then(function () {
    callback && callback();
  }).
  catch(function (err) {
    onError && onError(err);
  });
}